/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGATourModelUpdateFeatureInput = {|
  featureId: string,
  calculationId?: ?string,
  weight?: ?number,
  clientMutationId?: ?string,
|};
export type PGAModelBuilderCalcTabUpdateFeatureMutationVariables = {|
  input: PGATourModelUpdateFeatureInput
|};
export type PGAModelBuilderCalcTabUpdateFeatureMutationResponse = {|
  +pgaTourModelUpdateFeature: ?{|
    +success: ?boolean
  |}
|};
export type PGAModelBuilderCalcTabUpdateFeatureMutation = {|
  variables: PGAModelBuilderCalcTabUpdateFeatureMutationVariables,
  response: PGAModelBuilderCalcTabUpdateFeatureMutationResponse,
|};
*/


/*
mutation PGAModelBuilderCalcTabUpdateFeatureMutation(
  $input: PGATourModelUpdateFeatureInput!
) {
  pgaTourModelUpdateFeature(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PGATourModelUpdateFeaturePayload",
    "kind": "LinkedField",
    "name": "pgaTourModelUpdateFeature",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderCalcTabUpdateFeatureMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAModelBuilderCalcTabUpdateFeatureMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "11c830ae28d921e3d4f1cd1fd64b78e6",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderCalcTabUpdateFeatureMutation",
    "operationKind": "mutation",
    "text": "mutation PGAModelBuilderCalcTabUpdateFeatureMutation(\n  $input: PGATourModelUpdateFeatureInput!\n) {\n  pgaTourModelUpdateFeature(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5a239e8c20dd8c8c1180c84c46e25f81';

module.exports = node;
